import { type Message, StyledPillButton, strings, text } from "@quickpoint.me/shared";

import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { LocaleAtom } from "../../state/localeAtom";
import { HostId } from "../../state/atoms";

function ToggleSharePanelButton() {
	useRecoilValue(LocaleAtom); // re-render on locale change
	const toAuthorBC = new BroadcastChannel(strings.broadcastChannel.author);
	const hostId = useRecoilValue(HostId);

	const toggle = () => {
		const message: Message = {
			hostId,
			type: "fileUploader",
			action: strings.messages.toggleSharePanel,
		};
		toAuthorBC.postMessage(message);
	};

	useEffect(() => {
		return () => toAuthorBC.close();
	});

	return (
		<StyledPillButton data-testid="share-panel-toggle" onClick={toggle}>
			{text.ui.done}
		</StyledPillButton>
	);
}

export default ToggleSharePanelButton;
